import { render, staticRenderFns } from "./NewsEsnet.vue?vue&type=template&id=0b9e58b5&scoped=true&"
import script from "./NewsEsnet.vue?vue&type=script&lang=js&"
export * from "./NewsEsnet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9e58b5",
  null
  
)

export default component.exports